<template>
  <!-- Widgets wrapper -->
  <b-col :cols="customization.size">
    <b-card
      no-body
      :style="setBgColor(customization.color)"
      :class="customClasses"
    >
      <b-card-body>
        <Component
          :key="key"
          v-if="component"
          :is="component"
          :widget="widget"
          :customization="customization"
        />
      </b-card-body>
      <b-card-footer v-if="isOnCustomizationMode">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex" style="column-gap: 1em">
            <LmSelect
              class="m-0 d-flex align-items-center"
              v-model="customization.size"
              :options="sizeOptions"
              @input="onSizeChange"
            />
            <LmColorPicker
              :key="key"
              v-if="showColorPicker"
              class="mt-1"
              :swatches="swatches"
              v-model="customization.color"
              @input="onColorChange"
            />
            <LmTextInput
              v-if="showTitleInput"
              class="mb-0"
              v-model="customization.text"
              placeholder="Escribe un título"
              @input="onTitleChange"
            />
          </div>
          <font-awesome-icon @click="onWidgetRemove" style="width:18px;height:18px" icon="times" class="clickable"></font-awesome-icon>
        </div>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
// Components
import LmSelect from '@/components/form/elements/LmSelect'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmColorPicker from '@/components/form/elements/LmColorPicker'

// Widgets components
import LmList from '@/components/widgets/elements/LmList'
import LmTitle from '@/components/widgets/elements/LmTitle'

export default {
  props: {
    widget: {
      type: Object,
      required: true
    },
    component: {
      type: String,
      required: true
    },
    // Perzonalización realizada por el usuario final (viene de la colección lml_dashboard)
    customization: {
      type: Object,
      default: () => ({})
    },
    isOnCustomizationMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LmSelect,
    LmTextInput,
    LmColorPicker,
    LmList,
    LmTitle
  },
  data () {
    return {
      key: 0,
      swatches: [
        ['#F6648B', '#F493A7', '#F891A6', '#FFCCD5'],
        ['#a27bff', '#b99cff', '#d0bdff', '#e8deff'],
        ['#74ebe3', '#96f0ea', '#b9f5f1', '#dcfaf8'],
        ['#ffb748', '#ffc976', '#ffdba3', '#ffedd1'],
        ['']
      ],
      sizes: {
        3: '25%',
        6: '50%',
        9: '75%',
        12: '100%'
      }
    }
  },
  computed: {
    // Condicionales para componentes segun el widget
    showColorPicker () {
      if (this.component === 'LmTitle') {
        return false
      }
      return true
    },
    showTitleInput () {
      if (this.component === 'LmTitle') {
        return true
      }
      return false
    },
    // Clases segun el widget
    customClasses () {
      if (this.component === 'LmTitle') {
        return 'bg-light'
      }
      return 'shadow'
    },
    // Opciones de tamaños
    sizeOptions () {
      if (this.widget?.sizes) {
        const options = this.widget.sizes.map(s => {
          return {
            value: s,
            text: this.sizes[s]
          }
        })
        return {
          content: options
        }
      }
      // Si no existe la propiedad "sizes", no muestro opciones
      return {
        content: []
      }
    }
  },
  methods: {
    setBgColor () {
      if ('color' in this.customization) {
        return `background-color: ${this.customization.color}`
      }
      return ''
    },
    setColsSize () {
      if ('size' in this.customization) {
        return this.customization.size
      }
      return 12
    },
    onWidgetRemove () {
      this.$emit('onWidgetRemove')
    },
    onSizeChange (event) {
      this.$emit('onWidgetCustomizationChange', { size: event })
      this.key++
    },
    onColorChange (event) {
      this.$emit('onWidgetCustomizationChange', { color: event })
      this.key++
    },
    onTitleChange (event) {
      this.$emit('onWidgetCustomizationChange', { title: event })
      this.key++
    }
  }
}
</script>
